import * as types from "./actionTypes";

export const store = (data, path) => {
  return {
    type: types.PROJECT_SETTING_STORE_REQUEST,
    data: data,
    path
  };
};

export const storeSuccess = data => {
  return {
    type: types.PROJECT_SETTING_STORE_SUCCESS,
    payLoad: data
  };
};

export const storeFailure = () => {
  return {
    type: types.PROJECT_SETTING_STORE_FAILURE
  };
};

export const getList = () => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_REQUEST
  };
};

export const getListSuccess = (data) => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_SUCCESS,
    payLoad: data
  };
};

export const getListFailure = () => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_FAILURE
  };
};

export const sharedContacts = () => {
  return {
    type: types.SHARED_CONTACTS_REQUEST
  };
};

export const sharedContactsSuccess = (data) => {
  return {
    type: types.SHARED_CONTACTS_SUCCESS,
    payLoad: data
  };
};

export const sharedContactsFailure = () => {
  return {
    type: types.SHARED_CONTACTS_FAILURE
  };
};

export const setUserState = (userId, action) => {
  return {
    type: types.SET_USER_STATE_REQUEST,
    userId,
    action
  };
};

export const setUserStateSuccess = (data) => {
  return {
    type: types.SET_USER_STATE_SUCCESS,
    payLoad: data
  };
};

export const setUserStateFailure = (data) => {
  return {
    type: types.SET_USER_STATE_FAILURE,
    payLoad: data
  };
};